import type { ComponentDesktopKeyMap, ComponentDesktopMap, MainHomeDesktopProps } from './types';

export const parseRootDesktopProps = (props: MainHomeDesktopProps['props']): ComponentDesktopMap => {
	const returnValue: ComponentDesktopMap = {};

	const componentsNames: Record<string, ComponentDesktopKeyMap> = {
		'blog-feed': 'blog',
		blog: 'blog',
		'collapse-links-products': 'collapseLinksProducts',
		comarketing: 'comarketing',
		features: 'features',
		'header-carousel-rxjs': 'headerCarousel',
		'list-card-simple-hover': 'listCardSimpleHover',
		'masonry-carousel': 'masonryCarousel',
		'newsletter-subscription': 'newsletterSubscription',
		'products-banner': 'productsBanner',
		'section-image-link': 'sectionImageLink',
		'tabs-banner-product-card-carousel': 'tabsProductCard',
		multisearcher: 'multisearcher',
		'alex-trustedshops': 'trustedShops',
		'banner-button-width': 'bannerButtonWidth',
		'last-news': 'lastNews',
		'map-coasts': 'mapCoasts',
	};

	Object.entries<any>(props).forEach(([propsKey, propsValue]) => {
		if (!propsValue) return;

		const { name } = propsValue;
		const key = componentsNames[name];
		if (key) returnValue[key] = propsValue;
		else if (typeof propsValue === 'object') returnValue[propsKey as ComponentDesktopKeyMap] = propsValue;
	});

	return returnValue;
};
